import Image, { ImageProps } from 'next/image';
import { useMemo } from 'react';
import ImageWrapper, { Props as ImageWrapperProps } from './ImageWrapper';

export interface Props
  extends Omit<ImageProps, 'alt'>,
    ImageWrapperProps,
    React.PropsWithChildren {
  alt?: ImageProps['alt'];
}

export default function CoverImage({
  $width,
  $height,
  alt,
  sizes: sizesProps,
  children,
  ...props
}: Props) {
  const sizes = useMemo(() => sizesProps ?? 'auto', [sizesProps]);

  return (
    <ImageWrapper $rounded="xl" $width={$width} $height={$height} {...props}>
      <Image
        fill
        alt={alt ?? ''}
        sizes={sizes}
        style={{ objectFit: 'cover' }}
        {...props}
      />
      {children}
    </ImageWrapper>
  );
}
